import React, { useEffect, useState } from "react";
import "./HeroSection.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { fetchHeroSlides } from "../../api/hero.api";

const AUTO_SLIDE_INTERVAL = 6000;

export const HeroSection = () => {
  const [slides, setSlides] = useState([]);
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHeroSlides()
      .then((data) => setSlides(Array.isArray(data) ? data : []))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!slides.length) return;
    const timer = setInterval(() => {
      setIndex((i) => (i === slides.length - 1 ? 0 : i + 1));
    }, AUTO_SLIDE_INTERVAL);
    return () => clearInterval(timer);
  }, [slides]);

  const prevSlide = () =>
    setIndex((i) => (i === 0 ? slides.length - 1 : i - 1));
  const nextSlide = () =>
    setIndex((i) => (i === slides.length - 1 ? 0 : i + 1));

  if (loading) return <div className="hero-empty">Loading…</div>;
  if (!slides.length)
    return <div className="hero-empty">No offers available</div>;

  const activeSlide = slides[index];

  return (
    <section className="hero-section">
      <div className="dropfilter" />

      <div className="hero-bg">
        <img src={activeSlide.image_url} alt="Hero" />
      </div>

      {/* CONTENT GRID */}
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">{activeSlide.title}</h1>


          <p className="hero-sub">{activeSlide.subtitle}</p>

          {/* CTA ROW */}
          <div className="hero-cta-row">
            

            <div className="hero-arrows">
              <button className="arrow-btn" onClick={prevSlide}>
                <FaArrowLeft />
              </button>
              <button className="arrow-btn primary" onClick={nextSlide}>
                <FaArrowRight />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* DOTS */}
      <div className="slider-dots">
        {slides.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === index ? "active" : ""}`}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </section>
  );
};
